
<div class="modal-content-container">
  <a id="close-dialog-alta" class="close-dialog" (click)="closeDialog()">
    <img src="assets/images/icons/close_dialog_icon.svg" alt="close">
  </a>
  <div class="modal-title">
    <div class="icon">
      <img src="assets/images/icons/checkmark_success.svg">
    </div>
  </div>
  <div class="modal-body">
    <p>{{'TOKEN_UNLOCKED'|translate}}</p>
  </div>
  
</div>